import { useTranslation } from "react-i18next";
import { EnabledPopularItemText } from "./styles";
import { FormProvider, Controller } from "react-hook-form";
import { Divider, FormControlLabel, FormGroup, Switch, Typography } from "@mui/material";

const PopularItemSettings = ({ popularItemSettings, handleSubmit }) => {
  const { t } = useTranslation();
  const showAutomationCreate = popularItemSettings.getValues('popularItemSettings.enabled');

  return (
    <FormProvider {...popularItemSettings}>
      <form onSubmit={popularItemSettings.handleSubmit(handleSubmit)}>
        <Typography sx={{ mb: 2, fontSize: '24px'}}>Popular Item</Typography>
        <FormGroup>
          <Controller
            name="popularItemSettings.enabled"
            control={popularItemSettings.control}
            render={({ field }) => (
              <FormControlLabel
                sx={{ width: 'max-content' }}
                control={
                  <Switch
                    {...field}
                    checked={Boolean(field.value)}
                    onChange={(e) => field.onChange(e.target.checked)}
                  />
                }
                label={t('Enable Popular Item')}
              />
            )}
          />
        </FormGroup>
        <EnabledPopularItemText>
          {t('When you turn on this switcher, any item you mark as “popular” will automatically show up on website. But if you turn the switcher off, and then add a popular item manually from the “Popular Item” tab, that item won’t appear on Website.')}
        </EnabledPopularItemText>
        {showAutomationCreate ? (
          <>
            <Divider sx={{ mb: 4, mt: 4 }} />
            <FormGroup>
              <Controller
                name="popularItemSettings.automationCreate"
                control={popularItemSettings.control}
                render={({ field }) => (
                  <FormControlLabel
                    sx={{ width: 'max-content' }}
                    control={
                      <Switch
                        {...field}
                        checked={Boolean(field.value)}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    }
                    label={t('Popular Item Automation')}
                  />
                )}
              />
          </FormGroup>
          <EnabledPopularItemText>
            {t('Automatically mark items as popular based on sales trends. Enable or disable this setting to control whether popular items are selected automatically, while still allowing manual selection.')}
          </EnabledPopularItemText>
        </>
        ) : null}
      </form>
    </FormProvider>
  );
};

export default PopularItemSettings;
